import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Space,
  Avatar,
  Dropdown,
  Typography,
  Grid,
  Spin,
  Modal,
  Badge,
  Tooltip,
  Table,
  message,
  Form,
  Input,
  AutoComplete
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SettingOutlined,
  LogoutOutlined,
  BellOutlined,
  UserOutlined,
  LockOutlined,
  HistoryOutlined,
  QuestionCircleOutlined,
  SafetyCertificateOutlined,
  FileTextOutlined,
  FileProtectOutlined,
  MailOutlined,
  InfoCircleOutlined,
  DownOutlined,
  LoadingOutlined,
  CheckCircleTwoTone,
  SearchOutlined,
  CloseOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../pages/Auth/authThunks";
import SearchBox from "./components/SearchBox";
import RightSidebar from "../RightSidebar";
import OnboardingCTA from "./OnboardingCTA";
import { getBranchApi, getExpiryNotificationApi, getLoginHistory, switchBranchApi, updatePasswordApi, getAttendanceNotificationApi } from "../../apiservice/setting";
import { setNotificationCount } from "../../store/commonSlices/notificationSlice";
import { selectAuthInfo } from "../../pages/Auth/authSelectors";
import { loadAllNotifications } from "../../store/commonThunks/notificationsThunk";
import { setSwitchBranch } from "../../pages/Auth/authSlice";
import { isAdminUser } from "../../utils/accessChecker";
import { loadCrmNotifications } from "../../pages/Crm/crmNotificationThunk";
import HelpFaq from "../Faq/HelpFaq";

const { Header } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const TriacHeader = ({ collapsed, setCollapsed, setDrawerVisible }) => {
  const screens = useBreakpoint();
  const authInfo = useSelector(selectAuthInfo);
  const user = useSelector((state) => state.auth.user);
  const firstLetter = user?.full_name?.charAt(0) || user?.name?.charAt(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notificationCount = useSelector((state) => state.notifications.count);
  const crmData = useSelector((s) => s.crmNotifications.data);
  const finalCount = notificationCount + (crmData?.total ? 1 : 0);
  const isLoading = useSelector((state) => state.auth.isLoading);

  const [isProfileVisible, setProfileVisible] = useState(false);
  const [rightbarVisible, setRightbarVisible] = useState(false);
  const [isLoginHistoryVisible, setLoginHistoryVisible] = useState(false);
  const [isFaqVisible, setFaqVisible] = useState(false);
  const [loginHistory, setLoginHistory] = useState([]);
  const [loginHistoryLoading, setLoginHistoryLoading] = useState(false);
  const [isChangePasswordVisible, setChangePasswordVisible] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const [changePasswordValues, setChangePasswordValues] = useState({
    current_password: "",
    password: "",
    confirm_password: "",
  });
  // 🔹 Branch switch modal controls
  const [searchModalVisible, setSearchModalVisible] = useState(false);
  const [isSwitchBranchVisible, setSwitchBranchVisible] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [switchPassword, setSwitchPassword] = useState("");
  const [switchLoading, setSwitchLoading] = useState(false);
  const [switchSuccess, setSwitchSuccess] = useState(false);
  const [showOnboardingWizard, setShowOnboardingWizard] = useState(false);

console.log('',selectedBranch)

  const valueCellStyle = {
    padding: "10px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    maxWidth: "100%",
  };

  const wrapCellStyle = {
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "1.4",
  };
  // Login History
  const loginHistoryColumns = [
    {
      title: "Time", dataIndex: "created_date", key: "time", width: 160,
      render: (text) => (
        <div style={wrapCellStyle}>{text}</div>
      ),
    },
    { title: "Browser", dataIndex: "browser", key: "browser" },
    { title: "OS", dataIndex: "os", key: "os" },
    { title: "Device", dataIndex: "device_type", key: "device" },
    { title: "Model", dataIndex: "device_model", key: "model" },
    {
      title: "Location", dataIndex: "address", key: "address", width: 220,
      render: (text) => (
        <div style={wrapCellStyle}>{text}</div>
      ),
    },
  ];

  const fetchLoginHistory = async () => {
    setLoginHistoryLoading(true);
    try {
      const res = await getLoginHistory();
      const data = res.data.map((item) => ({
        ...item,
        created_date: new Date(item.created_date).toLocaleString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
      }));
      setLoginHistory(data);
    } catch (err) {
      console.error("Error fetching login history:", err);
    } finally {
      setLoginHistoryLoading(false);
    }
  };


  const hasCheckedOnboarding = useRef(false);

  useEffect(() => {
    if (!authInfo) return;

    const hasStartedOnboarding = sessionStorage.getItem("onboarding_started") === "true";

    const isOnboardingPage = window.location.pathname.includes("institution-profile");
    if (isOnboardingPage) return;

    const shouldShowOnboardingCTA =
      !isOnboardingPage && !hasStartedOnboarding &&
      isAdminUser(authInfo?.userInfo?.user_role_names) &&
      (authInfo?.onboarding_status === null ||
        authInfo?.onboarding_status === "pending" ||
        authInfo?.onboarding_status === "skipped_once");

    console.log("shouldShowOnboardingCTA : ", shouldShowOnboardingCTA)

    setShowOnboardingWizard(shouldShowOnboardingCTA);

  }, [authInfo, navigate,]);


  useEffect(() => {
    dispatch(loadAllNotifications({ onlyIncludeHr: false }));
    dispatch(loadCrmNotifications());
  }, []);

  const localAuthInfo = JSON.parse(localStorage.getItem("auth_info"));
  const isEmployee = localAuthInfo?.employee_id && localAuthInfo.employee_id !== 0;
  const trialMode = localAuthInfo?.trial_mode == "yes";
  const subscriptionMessage = authInfo?.subscriptionMessage;
  const daysLeft = Number(authInfo?.daysLeft);

  // // 🔄 Auto-refresh notification count every 2 mins
  // useEffect(() => {
  // const fetchCount = async () => {
  //   try {
  //     const res = await getExpiryNotificationApi();
  //     dispatch(setNotificationCount(res?.data?.data?.length || 0));
  //   } catch (err) {
  //     console.error("Error fetching notification count:", err);
  //   }
  // };

  // fetchCount(); // 🔔 once on app load
  // }, [dispatch]);




  const handleMenuClick = async ({ key }) => {
    switch (key) {
      case "1":
        setProfileVisible(true);
        break;
      case "switch-branch":
        setSwitchBranchVisible(true);
        fetchBranches();
        break;
      case "contact":
        navigate("/contact-support");
        break;
      case "privacy":
        navigate("/privacy-policy");
        break;
      case "terms":
        navigate("/terms-service");
        break;
      case "cookies":
        navigate("/cookies-policy");
        break;
      case "login-history":
        setLoginHistoryVisible(true);
        fetchLoginHistory();
        break;
      case "help-faq":
        setFaqVisible(true);
        break;
      case "change-password":
        setChangePasswordVisible(true);
        break;
      case "2":
        setProfileVisible(true);
        break;
      case "3":
        navigate("/settings");
        break;
      case "4":
        try {
          await dispatch(logoutUser()).unwrap();
        } catch (err) {
          console.warn("Logout failed, forcing client reset", err);
        } finally {
          navigate("/login");
          window.location.reload();
        }
        break;
      default:
        break;
    }
  };


  const items = [
    { key: "1", label: user?.full_name || user?.name, icon: <UserOutlined /> },
    { key: "switch-branch", label: "Switch Branch", icon: <UserOutlined /> },
    { key: "contact", label: "Contact Us", icon: <MailOutlined /> },
    { key: "privacy", label: "Privacy Policy", icon: <FileProtectOutlined /> },
    { key: "terms", label: "Terms of Service", icon: <FileTextOutlined /> },
    { key: "cookies", label: "Cookies Policy", icon: <SafetyCertificateOutlined /> },
    { key: "login-history", label: "Login History", icon: <HistoryOutlined /> },
    { key: "help-faq", label: "Help & FAQ", icon: <QuestionCircleOutlined /> },
    { type: "divider" },
    { key: "3", label: "Settings", icon: <SettingOutlined /> },
    { key: "change-password", label: "Change Password", icon: <LockOutlined /> },
    { type: "divider" },
    { key: "4", label: "Logout", icon: <LogoutOutlined />, danger: true },
  ];


  const userMenu = (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
      }}
    >
      <a onClick={(e) => e.preventDefault()}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: screens.xs ? "6px" : "10px",
          }}
        >
          {isLoading ? (
            <Spin size="small" />
          ) : (
            <Avatar
              size={screens.xs ? 28 : 40}
              style={{
                background: "#001529",
                color: "#fff",
                fontSize: screens.xs ? "14px" : "16px",
              }}
            >
              {firstLetter}
            </Avatar>
          )}

          {/* Text section */}
          {!screens.xs && <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              lineHeight: 1.2,
              color: "#fff",
            }}
          >
            <Text
              strong
              style={{
                color: "#fff",
                fontSize: screens.xs ? "12px" : "14px",
                margin: 0,
                padding: 0,
              }}
            >
              {user?.full_name || user?.name || "User"}
            </Text>

            <span
              style={{
                fontWeight: 400,
                fontSize: "11px",
                color: "#b3c6ff",
                textDecoration: "underline",
                cursor: "pointer",
                marginTop: "2px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setSwitchBranchVisible(true);
                fetchBranches();
              }}
            >
              ({user?.branch_name || "Switch Branch"})
            </span>
          </div>}
        </div>
      </a>

    </Dropdown>
  );


  // SWITCHING BRANCH
  const fetchBranches = async () => {
    try {
      const res = await getBranchApi();
      const data = res.data?.message || [];

      const filtered = data.filter(
        (b) => b.id !== user?.branch_id // Exclude current branch
      );
      setBranches(filtered);
    } catch (err) {
      console.error(err);
      message.error("Error fetching branches");
    }
  };

  const branchValidatePassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(password);

  const handleSwitchBranch = async () => {
    if (!selectedBranch) {
      message.warning("Please select a branch to switch.");
      return;
    }
    if (!switchPassword.trim()) {
      message.warning("Password is required.");
      return;
    }
    if (!branchValidatePassword(switchPassword)) {
      message.error("Invalid password format.");
      return;
    }

    setSwitchLoading(true);
    try {
      const payload = {
        password: switchPassword,
        new_branch_id: selectedBranch.id,
        new_branch_name: selectedBranch.name,
      };
      const res = await switchBranchApi(payload);
      if (res?.data?.error === false) {
        setSwitchSuccess(true);

        localStorage.setItem("auth_info", JSON.stringify(res.data));
        localStorage.setItem("token", res.data.token); // ✅ update token
        dispatch(setSwitchBranch(res.data)); // ✅ update Redux immediately

        message.success("Branch switched successfully. Reloading...");
        setTimeout(() => {
          setSwitchSuccess(false);
          setSwitchLoading(false);
          window.location.reload();
        }, 1300);
      } else {
        message.warning(res?.data?.message || "Failed to switch branch.");
        setSwitchLoading(false);
      }
    } catch (err) {
      message.error("Error switching branch. Try again.");
      console.error(err);
    } finally {
      setSwitchLoading(false);
    }
  };

  // HANDLING PASSWORD CHANGES
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setChangePasswordValues((prev) => ({ ...prev, [name]: value }));
  };

  const resetChangePasswordForm = () => {
    setChangePasswordValues({
      current_password: "",
      password: "",
      confirm_password: "",
    });
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/;
    return regex.test(password);
  };

  const handleSubmitChangePassword = async () => {
    const { current_password, password, confirm_password } = changePasswordValues;

    if (!current_password || !password || !confirm_password) {
      message.warning("All fields are required.");
      return;
    }
    if (password !== confirm_password) {
      message.error("Password and Confirm Password do not match.");
      return;
    }
    if (!validatePassword(password)) {
      message.error(
        "Password must be 8-16 characters, include uppercase, lowercase, number and special character."
      );
      return;
    }

    setChangePasswordLoading(true);
    try {
      const payload = {
        email: user?.email,
        currentPassword: current_password,
        password,
        institution_id: user?.pro_id,
      };

      const res = await updatePasswordApi(payload);

      // ✅ The backend always returns status 200, so check message instead
      if (res?.data?.message?.toLowerCase().includes("success")) {
        message.success("Password updated successfully. Please log in again.");
        resetChangePasswordForm();
        setChangePasswordVisible(false);

        await dispatch(logoutUser()).unwrap();
        navigate("/login");
        window.location.reload();
      } else {
        message.error(res?.data?.message || "Password update failed.");
      }
    } catch (err) {
      message.error("Error updating password. Try again.");
      console.error("Change Password error:", err);
    } finally {
      setChangePasswordLoading(false);
    }
  };

  const MOBILE_HEADER_BASE = 80;



  return (
    <>
      <Header
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          zIndex: 1000,
          width: !screens.md
            ? "100%"
            : `calc(100% - ${collapsed ? "80px" : "200px"})`,
            transition: "width 0.3s ease",
          height: !screens.md ? `calc(${MOBILE_HEADER_BASE}px + env(safe-area-inset-top))` : undefined,
          padding: screens.xs ? "0 10px" : "0 20px",
          paddingTop: screens.xs
            ? "calc(40px + env(safe-area-inset-top))"
            : "0px",
          marginLeft: !screens.xs && "-25px",
          display: "flex",
          alignItems: "center",
          background: "linear-gradient(90deg, #001529, #003a8c)",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >

        {/* Hamburger Icon */}
        <div style={{ flex: "0 0 auto" }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => {
              if (screens.md) {
                setCollapsed(!collapsed);
              } else {
                setDrawerVisible(true);
              }
            }}
            style={{ fontSize: "20px", color: "#fff" }}
          />
        </div>

        {/* Search Box */}
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: screens.xs ? "flex-start" : "center",
            alignItems: "center",
            maxWidth: screens.xs ? "100%" : "auto",
            paddingLeft: screens.xs ? 8 : 0,
            paddingRight: screens.xs ? 8 : 0,
          }}
        >
          {screens.xs ? (
            <Button
              type="text"
              icon={<SearchOutlined style={{ fontSize: 20, color: "#fff" }} />}
              onClick={() => setSearchModalVisible(true)}
            />
          ) : (
            <SearchBox />
          )}

        </div>

        {/* Right Section */}
        <div style={{ flex: "0 0 auto" }}>
          <Space>
            {trialMode && <>
              <Badge
                color={trialMode ? "orange" : ""}
                text={
                  <span style={{
                    fontSize: screens.xs ? "16px" : "20px", // smaller bell on mobile
                    color: "#fff",
                    transform: screens.xs ? "translateX(0)" : "translateX(-8px)" // no shift on mobile
                  }}>
                    {trialMode ? "  Free Version" : ""}
                  </span>
                }
              />
            </>}

            {isEmployee && (
              <Tooltip title="Mark Attendance">
                <Button
                  type="text"
                  shape="circle"
                  icon={
                    <ClockCircleOutlined
                      style={{
                        fontSize: screens.xs ? "16px" : "20px", // smaller bell on mobile
                        color: "#fff",
                        transform: screens.xs ? "translateX(0)" : "translateX(-8px)" // no shift on mobile
                      }}
                    />
                  }
                  onClick={() => navigate("/hrpayroll/attendance-overview?markAttendance=1")}
                />
              </Tooltip>
            )}



            {/* 🔔 Notification Toggler */}
            <Badge
              count={finalCount ? finalCount : notificationCount}
              size={screens.xs ? "default" : "small"} // bigger dot on mobile
              offset={screens.xs ? [-4, 4] : [-8, 6]} // tighter on mobile
            >
              <Button
                type="text"
                shape="circle"
                icon={
                  <BellOutlined
                    style={{
                      fontSize: screens.xs ? "16px" : "20px", // smaller bell on mobile
                      color: "#fff",
                      transform: screens.xs ? "translateX(0)" : "translateX(-8px)" // no shift on mobile
                    }}
                  />
                }
                onClick={() => setRightbarVisible(true)}
              />
            </Badge>
            {userMenu}
          </Space>
        </div>

      </Header>
      {subscriptionMessage && (
        <div
          style={{
            position: "fixed",
            top: screens.xs ? "80px" : "64px",
            right: 0,
            width: !screens.md
              ? "100%"
              : `calc(100% - ${collapsed ? "80px" : "200px"})`,
            transition: "width 0.3s ease",
            zIndex: 999,

            // 🎨 Simplified color logic (since you show only <=14)
            background:
              daysLeft <= 7
                ? "#f8d7da"   // red
                : "#fff3cd",  // yellow

            color:
              daysLeft <= 7
                ? "#842029"
                : "#856404",

            // ✅ Responsive font size
            fontSize: "clamp(11px, 2.5vw, 14px)",

            // ✅ Proper padding (fixes mobile height issue)
            padding: screens.xs ? "4px 8px" : "8px 16px",

            textAlign: "center",
            fontWeight: 500,
            borderBottom: "1px solid #ddd",

            // ✅ Prevent overflow issues
            lineHeight: 0.6,
            whiteSpace: "normal",
            wordBreak: "break-word",

            // ✅ Slight polish
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          {subscriptionMessage}
        </div>
      )}
      {/* Profile Modal */}
      <Modal
        title="Profile"
        open={isProfileVisible}
        onCancel={() => setProfileVisible(false)}
        footer={[
          <Button key="close" onClick={() => setProfileVisible(false)}>
            Close
          </Button>,
          <Button
            key="logout"
            danger
            type="primary"
            onClick={async () => {
              try {
                await dispatch(logoutUser()).unwrap();
              } catch (err) {
                console.warn("Logout failed, forcing client reset", err);
              } finally {
                navigate("/login");
                window.location.reload();
              }
            }}
          >
            Logout
          </Button>,
        ]}
      >
        <div
          style={{
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr style={{ background: "#fafafa" }}>
                <td style={{ padding: "10px", fontWeight: 600, width: "30%" }}>
                  Name
                </td>
                <td style={valueCellStyle}>
                  {user?.full_name || user?.name}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", fontWeight: 600 }}>Email</td>
                <td style={valueCellStyle}>{user?.email}</td>
              </tr>
              <tr style={{ background: "#fafafa" }}>
                <td style={{ padding: "10px", fontWeight: 600 }}>Branch</td>
                <td style={valueCellStyle}>
                  {user?.branch_name || "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>


      {/* 🏢 Switch Branch Modal */}
      <Modal
        title="Switch Branch"
        open={isSwitchBranchVisible}
        onCancel={() => {
          setSwitchBranchVisible(false);
          setSelectedBranch(null);
          setSwitchPassword("");
          setSwitchLoading(false);
          setSwitchSuccess(false);
        }}
        footer={null}
        centered
        width={450}
      >
        {switchLoading ? (
          <div style={{ textAlign: "center", padding: "30px" }}>
            {switchSuccess ? (
              <>
                <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 48 }} />
                <div style={{ marginTop: 12, fontWeight: 500 }}>Switched Successfully!</div>
              </>
            ) : (
              <>
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 36, color: "#1890ff" }} spin />}
                />
                <div style={{ marginTop: 12, fontWeight: 500 }}>Switching Branch...</div>
              </>
            )}
          </div>
        ) : (
          <Form layout="vertical">
            <Form.Item label="Select Branch" required>
              <AutoComplete
                style={{ width: "100%" }}
                options={branches.map((b) => ({
                  label: b.name,
                  value: b.name,
                  obj: b,
                }))}
                placeholder="Choose a branch"
                value={selectedBranch?.name ?? ""}
                onSelect={(value, option) => setSelectedBranch(option.obj)}
              />
            </Form.Item>

            <Form.Item
              label={
                <>
                  Enter Password{" "}
                  <Tooltip
                    title={
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        <li>8-16 characters</li>
                        <li>At least one uppercase letter</li>
                        <li>At least one lowercase letter</li>
                        <li>At least one number</li>
                        <li>At least one special character (@$!%*?&)</li>
                      </ul>
                    }
                  >
                    <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 6 }} />
                  </Tooltip>
                </>
              }
              required
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter your password"
                value={switchPassword}
                onChange={(e) => setSwitchPassword(e.target.value)}
              />
            </Form.Item>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <Button onClick={() => setSwitchBranchVisible(false)}>Cancel</Button>
              <Button type="primary" onClick={handleSwitchBranch}>
                Switch Branch
              </Button>
            </div>
          </Form>
        )}
      </Modal>




      {/* login history modal */}
      <Modal
        title="Login History"
        open={isLoginHistoryVisible}
        onCancel={() => setLoginHistoryVisible(false)}
        footer={null}
        width={1100}
      >
        {loginHistoryLoading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin tip="Loading..." />
          </div>
        ) : (
          <Table
            columns={loginHistoryColumns}
            dataSource={loginHistory}
            rowKey="id"
            pagination={false}
            scroll={{ x: "max-content" }}
          />
        )}
      </Modal>

      {/* Help & FAQ Modal */}
      <Modal
        title="Help & FAQ"
        open={isFaqVisible}
        onCancel={() => setFaqVisible(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <HelpFaq />
      </Modal>


      {/* Change Password Modal */}
      <Modal
        title="Change Password"
        open={isChangePasswordVisible}
        onCancel={() => {
          setChangePasswordVisible(false);
          resetChangePasswordForm();
        }}
        footer={null}
        centered
        width={500}
      >
        <Form layout="vertical">
          <Form.Item label="Current Password" required>
            <Input.Password
              name="current_password"
              value={changePasswordValues.current_password}
              onChange={handlePasswordChange}
              placeholder="Enter current password"
            />
          </Form.Item>

          <Form.Item
            label={
              <>
                New Password{" "}
                <Tooltip
                  title={
                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                      <li>8-16 characters</li>
                      <li>At least one uppercase</li>
                      <li>At least one lowercase</li>
                      <li>At least one number</li>
                      <li>At least one special character</li>
                    </ul>
                  }
                >
                  <InfoCircleOutlined style={{ marginLeft: 5, color: "#1890ff" }} />
                </Tooltip>
              </>
            }
            required
          >
            <Input.Password
              name="password"
              value={changePasswordValues.password}
              onChange={handlePasswordChange}
              placeholder="Enter new password"
            />
          </Form.Item>

          <Form.Item label="Confirm Password" required>
            <Input.Password
              name="confirm_password"
              value={changePasswordValues.confirm_password}
              onChange={handlePasswordChange}
              placeholder="Re-enter new password"
            />
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button onClick={resetChangePasswordForm}>Discard</Button>
            <Button
              type="primary"
              loading={changePasswordLoading}
              onClick={handleSubmitChangePassword}
            >
              Save
            </Button>
          </div>
        </Form>
      </Modal>
      {/* search box modal in mobile ui */}
      <Modal
        open={searchModalVisible}
        onCancel={() => setSearchModalVisible(false)}
        footer={null}
        closable={false}
        centered
        width="100%"
        style={{
          background: "transparent",
          boxShadow: "none",
          padding: 0,
        }}
        styles={{
          body: {
            background: "transparent",
            padding: 0,
            margin: 0,
            height: "4vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
          },
          mask: {
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
          }
        }}
      >
        {/* TOP ROW → Close Button */}
        {/* <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            padding: "0px 16px",
            height: "0px",
            // transform: "translate(0.2rem, -1.2rem)",
          }}
        >
          <Button
            type="text"
            onClick={() => setSearchModalVisible(false)}
            icon={<CloseOutlined style={{ fontSize: 26, color: "#000" }} />}
          />
        </div> */}

        {/* Search box - only item centered */}
        <div
          style={{
            width: "92%",
            maxWidth: 450,
            marginTop: 10,
          }}
        >
          <SearchBox
            onSelect={() => setSearchModalVisible(false)}
          />
        </div>
      </Modal>

      <OnboardingCTA visible={showOnboardingWizard} />



      {/* Right Sidebar Drawer */}
      <RightSidebar
        visible={rightbarVisible}
        onClose={() => setRightbarVisible(false)}
      />

    </>


  );
};

export default TriacHeader;
